module.exports = __webpack_public_path__ + "img/pig.9c5ddb75.svg";